export const formatFileType = (mimeType: string | undefined | null): string => {
  if (!mimeType) {
    return "Unknown";
  }

  const normalizedType = mimeType.toLowerCase().trim();

  if (normalizedType.startsWith("audio/")) {
    return "Audio";
  }

  if (normalizedType.startsWith("video/")) {
    return "Video";
  }

  return "Unknown";
};
